/**
 * useUiScale Hook
 * Manages the app-wide display scale ("zoom") preference. Reads the persisted value on mount,
 * and on change persists it and applies it live to the root element so the UI rescales
 * immediately (no reload). Persists to localStorage so it survives page reloads and logins.
 */
import { useState, useCallback } from 'react';
import { loadUiScale, saveUiScale, applyUiScale, UI_SCALE_OPTIONS } from '../utils/uiScale';

export default function useUiScale() {
  const [scale, setScaleState] = useState(() => loadUiScale());

  const setScale = useCallback((value) => {
    saveUiScale(value);
    applyUiScale(value);
    setScaleState(value);
  }, []);

  return { scale, setScale, options: UI_SCALE_OPTIONS };
}
